export default __webpack_public_path__ + "static/media/empty-state-background.8062b582.svg";